/**
 * 报警设置api
 * date:2022 04 13
 */
import httpRequest from '@/utils/request.js';

/**获取报警触发列表接口 */
export const alarmTriggerList = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/alarmTrigger/lst',
        params: {
            ...params
        }
    });
/**获取监测点绑定报警触发列表接口 */
export const getCarrierAlarmTrigger = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/alarmTrigger/getCarrierAlarmTrigger',
        params: {
            ...params
        }
    });
/**报错监测点绑定报警触发列表接口 */
export const saveCarrierAlarmTrigger = data => httpRequest.httpPost('/service/alarmTrigger/saveCarrierAlarmTrigger', data);
/**获取报警触发详细信息接口 */
export const alarmTriggerDetail = id =>
    httpRequest.httpGet({
        url: '/service/alarmTrigger/' + id
    });
/**获取报警联系人*/
export const alarmContactsList = (params = {}) =>
    httpRequest.httpGet({
        url: '/service/contacts/list',
        params: {
            ...params
        }
    });
/**新增报警触发接口 */
export const alarmAddAlarmTrigger = data => httpRequest.httpPost('/service/alarmTrigger/addAlarmTrigger', data);
/**编辑报警触发接口 */
export const alarmeditAlarmTrigger = data => httpRequest.httpPost('/service/alarmTrigger/editAlarmTrigger', data);
/**删除报警触发接口 */
export const alarmDelete = data => httpRequest.httpdelete('/service/alarmTrigger/delete', data);
/**删除报警触发接口 */
export const alarmDeleteBatch = data => httpRequest.httpdelete('/service/alarmTrigger/deleteBatch', data);

// 打开/关闭报警开关
export const editAlarmSwitch = params => httpRequest.httpPut('/service/alarmTrigger/switch', params);
